<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ `${profile.public_id} - ${$t($route.meta.title)}` }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn icon>
                                        <v-icon>sync</v-icon>
                                    </v-btn>
                                </template>
                                Sync Hologram
                            </bc-tooltip>
                            <bc-btn-refresh
                                @invoke-method="dbGetDevice()"
                            ></bc-btn-refresh>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text >
                    <v-layout row wrap>
                        <v-flex xs12>
                            <ul class="deviceInfo mb-2" v-if="$bp.smAndUp">
                                <li><div @mouseup.left="openBatteryGraph()" class="clickable"><span class="caption">Voltage:</span> 8.57</div></li>
                                <li><div><span class="caption">Temp:</span> 95&deg;F</div></li>
                                <li><div><span class="caption">Firmware:</span> {{ profile.formatted_version }}</div></li>
                                <li><div><span class="caption">Last Reading:</span> {{ profile.date_modified }}</div></li>
                            </ul>
                            <ul class="deviceInfo mb-2" v-if="$bp.xsOnly">
                                <li><div @mouseup.left="openBatteryGraph()" class="clickable"><span class="caption">Voltage:</span> 8.57</div></li>
                                <li><div><span class="caption">Temp:</span> 95&deg;F</div></li>
                            </ul>
                            <ul class="deviceInfo mb-2" v-if="$bp.xsOnly">
                                <li><div><span class="caption">Firmware:</span> {{ profile.formatted_version }}</div></li>
                            </ul>
                            <ul class="deviceInfo" v-if="$bp.xsOnly">
                                <li><div><span class="caption">Last Reading:</span> {{ profile.date_modified }}</div></li>
                            </ul>
                        </v-flex>
                    </v-layout>
                    <v-data-table
                        hide-headers
                        :items="['1', '2', '3', '4']"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable">
								<td>Pin {{ props.item }}</td>
								<td>{{ props.item }}</td>
								<td>{{ props.item }}</td>
								<td>{{ props.item }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-textarea
                                value="test"
                                label="Raw Log"
                                auto-grow
                                outline
                                readonly
                            ></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
        <bc-dialog v-model="batteryGraphDialog" max-width="700" fullscreen>
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('lang.battery_profile')}}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-refresh
                        @invoke-method="getBatteryGraph()"
                    ></bc-btn-refresh>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="batteryGraphDialog"
                        :dialog-status="batteryGraphDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <!-- battery chart goes here -->
                <v-card-text>
                    <v-container pa-0>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <bc-charts
                                    chart-type="stock"
                                    :chart-data="batteryData"
                                ></bc-charts>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </bc-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            device_id: null,
            batteryGraphDialog: false,
            batteryData: null,
            headers: [
                {
                    text: this.$t("lang.device_identifier"),
                    sortable: false,
                    width: "10%",
                },
                {
                    text: this.$t("lang.customer"),
                    sortable: false,
                    width: "20%",
                },
                { text: this.$t("lang.imei"), sortable: false, width: "10%" },
                {
                    text: this.$t("lang.sim_provider"),
                    sortable: false,
                    width: "10%",
                },
                { text: this.$t("lang.status"), sortable: false, width: "10%" },
                { text: this.$t("lang.term"), sortable: false, width: "10%" },
                {
                    text: this.$t("lang.renewal_date"),
                    sortable: false,
                    width: "10%",
                },
                { text: this.$t("lang.price"), sortable: false, width: "10%" },
                {
                    text: this.$t("lang.last_read"),
                    sortable: false,
                    width: "10%",
                },
            ],
            mobile_list: [
                { title: this.$t("lang.sync"), action: "syncHologram" },
                { title: this.$t("lang.refresh"), action: "dbGetDevice" },
            ],
            dbGetDevice: _.debounce(this.getDevice, 1500, {
                maxWait: 1500,
                leading: true,
                trailing: false,
            }),
        };
    },
    beforeRouteEnter(to, from, next) {
        store
            .dispatch("fetchDevices", {
                url: "devices/" + to.params.id,
                method: "get",
                stateProperty: "device|ports|entity_addresses",
                dataProperty: "device|device.ports|device.entity_addresses",
                commit: true,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.device) {
                    next((vm) => {
                        vm.device_id = to.params.id;
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        // this.$store.dispatch(
        //     "fetchDevices",
        //     {
        //         url: 'devices/billing',
        //         method: 'get',
        //         body: parsedQuery
        //     }
        // ).then((data) => {
        //     if (typeof(data) !== 'undefined' && data.firmware_versions)
        //     {
        //         this.setQuery(parsedQuery, this.filter, this.default_filter);
        //         this.finishLoader();
        //         next()
        //     }else{
        //         next({ name: 'dashboard', replace: true });
        //     }
        // })
        this.finishLoader();
        next();
    },
    computed: {
        ...mapState({
            profile: (state) => state.devices.device,
        }),
    },
    methods: {
        openBatteryGraph() {
            this.batteryGraphDialog = true;
            this.getBatteryGraph();
        },
        getDevice() {
            this.startLoader();
            this.$store
                .dispatch("fetchDevices", {
                    url: "devices/" + to.params.id,
                    method: "get",
                    stateProperty: "device|ports|entity_addresses",
                    dataProperty: "device|device.ports|device.entity_addresses",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined")
                        this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        getBatteryGraph() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchDevices", {
                    url: "devices/" + this.device_id + "/battery_graph",
                    method: "get",
                })
                .then((data) => {
                    if (data.battery_graph) {
                        this.batteryData = data.battery_graph;
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
    },
};
</script>
